export * from './ComponentResolver';
